module.exports = __webpack_public_path__ + "static/Apartmani-Mima-Sokobanja-23-a96c574194411dadc34e26fe42626b73.jpg";